/* eslint-disable default-param-last */
import {
  SET_MISSIONS_MONITORING,
  SET_MISSIONS_MONITORING_LOADING,
} from "../actions/actionTypes";

// Mission monitoring cached per campaign so the campaign page and its site pages
// share a single fetch instead of each re-fetching the same campaign data.
const initialState = {
  byCampaign: {},
  loading: {},
};

export default function missionMonitoring(state = initialState, action) {
  switch (action.type) {
    case SET_MISSIONS_MONITORING:
      return {
        ...state,
        byCampaign: {
          ...state.byCampaign,
          [action.campaignId]: action.missions,
        },
      };

    case SET_MISSIONS_MONITORING_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.campaignId]: action.loading,
        },
      };

    default:
      return state;
  }
}
